import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=b88bcfd2&"
import script from "./ComingSoon.vue?vue&type=script&lang=js&"
export * from "./ComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=b88bcfd2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88bcfd2')) {
      api.createRecord('b88bcfd2', component.options)
    } else {
      api.reload('b88bcfd2', component.options)
    }
    module.hot.accept("./ComingSoon.vue?vue&type=template&id=b88bcfd2&", function () {
      api.rerender('b88bcfd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/miscellaneous/ComingSoon.vue"
export default component.exports